import denaScanImg from './images/shared/denascan.png';


export { ReactComponent as AboutBigIcon } from './images/header/about-big.svg';
export { ReactComponent as AboutIcon } from './images/header/about.svg';
export { ReactComponent as AddIcon } from './images/shared/add.svg';
export { ReactComponent as AlertIcon } from './images/shared/alert.svg';
export { ReactComponent as ArrowIcon } from './images/shared/arrow.svg';
export { ReactComponent as ArrowBack } from './images/shared/arrow-back.svg';
export { ReactComponent as ArrowDown } from './images/shared/arrow-down-white.svg';
export { ReactComponent as BetaIcon } from './images/header/beta.svg';
export { ReactComponent as CodeIcon } from './images/header/code.svg';
export { ReactComponent as CogIcon } from './images/header/cog.svg';
export { ReactComponent as CopyIcon } from './images/shared/copy.svg';
export { ReactComponent as CloseGe } from './images/shared/close-ge.svg';
export { ReactComponent as CoinsIcon } from './images/shared/coins.svg';
export { ReactComponent as CoinEckoIcon } from './images/shared/coin-ecko.svg';
export { ReactComponent as CloseIcon } from './images/shared/cross.svg';
export { ReactComponent as DiscordIcon } from './images/header/discord.svg';
export { ReactComponent as DropdownGe } from './images/shared/dropdown-ge.svg';
export { ReactComponent as ErrorIcon } from './images/shared/error-circle.svg';
export { ReactComponent as ExplorerIcon } from './images/shared/ic_explorer.svg';
export { ReactComponent as GasIcon } from './images/shared/gas.svg';
export { ReactComponent as HamburgerIcon } from './images/header/hamburger.svg';
export { ReactComponent as HistoryIcon } from './images/shared/history.svg';
export { ReactComponent as EckoDexLightModeLogo } from './images/header/eckoDEX_dark.svg';
export { ReactComponent as EckoDexLogo } from './images/header/eckoDEX.svg';
export { ReactComponent as EckoLogoLoader } from './images/header/ecko-logo-loader.svg';
export { ReactComponent as KDALogo } from './images/header/kadena-logo.svg';
export { ReactComponent as EckoOutlineIcon } from './images/shared/ecko-outline.svg';
export { ReactComponent as LockLogo } from './images/shared/awesome-lock.svg';
export { ReactComponent as Logo } from './images/shared/Logo.svg';
export { ReactComponent as MenuGEIcon } from './images/shared/menu-ge.svg';
export { ReactComponent as NotificationCautionBlueIcon } from './images/shared/ic_caution_blue.svg';
export { ReactComponent as NotificationErrorIcon } from './images/shared/ic_error.svg';
export { ReactComponent as NotificationIcon } from './images/header/notification.svg';
export { ReactComponent as NotificationSuccessIcon } from './images/shared/ic_success.svg';
export { ReactComponent as NotificationWarningIcon } from './images/shared/ic_caution_orange.svg';
export { ReactComponent as OnOffIcon } from './images/shared/on-off.svg';
export { ReactComponent as PowerIcon } from './images/header/power.svg';
export { ReactComponent as RemoveIcon } from './images/shared/remove.svg';
export { ReactComponent as SearchGEIcon } from './images/shared/search-ge.svg';
export { ReactComponent as SearchIcon } from './images/shared/search.svg';
export { ReactComponent as SuccessfullIcon } from './images/shared/successful-circle.svg';
export { ReactComponent as SwapArrowsIcon } from './images/shared/invert.svg';
export { ReactComponent as SwapIcon } from './images/shared/swap-icon.svg';
export { ReactComponent as TelegramIcon } from './images/header/telegram.svg';
export { ReactComponent as ThreeDotsIcon } from './images/header/three_dots.svg';
export { ReactComponent as TorusLogo } from './images/shared/torus-logo.svg';
export { ReactComponent as TradeDownIcon } from './images/shared/trade-down.svg';
export { ReactComponent as TradeUpIcon } from './images/shared/trade-up.svg';
export { ReactComponent as VotingPowerFormulaIcon } from './images/shared/voting-power-formula.svg';
export { ReactComponent as ZelcoreLogo } from './images/shared/zelcore-logo.svg';
export { ReactComponent as WalletConnectLogo } from './images/shared/walletconnect-logo.svg';
export { ReactComponent as EckoWalletLogo } from './images/game-edition/eckoWALLET_logo.svg';
export { ReactComponent as InfoIcon } from './images/shared/info-icon.svg';
export { ReactComponent as BoosterIcon } from './images/shared/booster.svg';
export { ReactComponent as SimplexLogo } from './images/shared/simplex-logo.svg';
export { ReactComponent as SalesIcon } from './images/shared/sales.svg';
export { ReactComponent as TeamIcon } from './images/shared/team.svg';
export { ReactComponent as BurnedIcon } from './images/shared/burned.svg';
export { ReactComponent as DaoIcon } from './images/shared/dao.svg';
export { ReactComponent as CandlestickChartIcon } from './images/shared/candlestick-chart.svg';
export { ReactComponent as LineChartIcon } from './images/shared/line-chart.svg';
export { ReactComponent as NccLogo } from './images/shared/ncc-logo.svg';
export { ReactComponent as NccLogoLightMode } from './images/shared/ncc-logo-light.svg';
export { ReactComponent as WarningIcon } from './images/header/warning-icon.svg';
export { ReactComponent as PumpIcon } from './images/header/petrol-pump.svg';
export { ReactComponent as ChainIcon } from './images/shared/chain.svg';
export { ReactComponent as UnknownLogo } from './images/shared/unknown_new.svg';
export { ReactComponent as VerifiedLogo } from './images/shared/verified.svg';
export { ReactComponent as VerifiedBoldLogo } from './images/shared/bold_verified.svg';
export { ReactComponent as LiquidityDollarLogo } from './images/shared/liquidity_dollar.svg';
export { ReactComponent as AddLiquidityLogo } from './images/shared/add_liquidity.svg';
export { ReactComponent as VaultIcon } from './images/shared/vault.svg';
export { ReactComponent as SKDXIcon } from './images/shared/skdx-logo.svg';
export { ReactComponent as KadenaExplorerLogo } from './images/shared/kadena-explorer-logo.svg';
export { ReactComponent as LinxLogoLight } from './images/shared/linx-logo-light.svg';
export { ReactComponent as CircleInfo } from './images/shared/circle-info.svg';
export { ReactComponent as KadenaSimpleLogo } from './images/shared/kadena_simple.svg';
export const DenaScanLogo = (props) => <img src={denaScanImg} alt="logo" {...props} />

export * from '../assets/images/game-edition';
export * from './socials';
